import { render, staticRenderFns } from "./IconTikTok.vue?vue&type=template&id=3a197506&scoped=true&"
import script from "./IconTikTok.vue?vue&type=script&lang=js&"
export * from "./IconTikTok.vue?vue&type=script&lang=js&"
import style0 from "./IconTikTok.vue?vue&type=style&index=0&id=3a197506&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a197506",
  null
  
)

export default component.exports